// extracted by mini-css-extract-plugin
module.exports = {"email-suggester":"_2ZSlh","email-suggester__suggestion":"COKP4","suggestion__domain":"_2qQR-","suggestion__input-mask":"_1yyXQ"};